import React, { useState, useEffect } from "react";
import { db } from "./firebase";
import { doc, getDoc, setDoc } from "./firebase-shim";
import PonteggioProgetto from "./PonteggioProgetto"; // PONT_PROGETTO_v1 PONT_STAMPA_v1 PONT_PIMUS_v1 PONT_USCITE_v1

// PONT_EDIFICIO_v1 - descrizione dell'edificio per il progetto del ponteggio (impostazioni/ponteggio_<idCantiere>)

const TIPI_EL = [
  { k: "balcone", n: "Balcone", c: "#3b82f6", sporg: true },
  { k: "canna", n: "Canna fumaria / sporgenza", c: "#ef4444", sporg: true },
  { k: "finestra", n: "Finestra / apertura", c: "#94a3b8", sporg: false },
  { k: "passo", n: "Passo carraio / ingresso", c: "#f59e0b", sporg: false },
  { k: "no_anc", n: "Zona NON adatta agli ancoraggi", c: "#dc2626", sporg: false },
  { k: "struttura", n: "Trave / pilastro in c.a. (ancoraggio buono)", c: "#16a34a", sporg: false },
  { k: "partenza", n: "Partenza particolare (tetto, terrazzo...)", c: "#a855f7", sporg: false },
  { k: "montacarichi", n: "Montacarichi a bandiera", c: "#0ea5e9", sporg: false }, // PONT_MONTA_v1
  { k: "altro", n: "Altro ostacolo", c: "#64748b", sporg: true },
];
const tipoEl = k => TIPI_EL.find(t => t.k === k) || TIPI_EL[TIPI_EL.length - 1];

const num = v => { const n = parseFloat(String(v === undefined || v === null ? "" : v).replace(",", ".")); return isNaN(n) ? 0 : n; };
const f2 = v => (Math.round(num(v) * 100) / 100).toLocaleString("it-IT");
const nuovoId = () => "x" + Date.now() + Math.floor(Math.random() * 1000);
const lettera = i => String.fromCharCode(65 + (i % 26));

const latoVuoto = i => ({
  id: nuovoId(), nome: "Lato " + lettera(i), lunghezza: 10, angolo: 90,
  distanzaMuro: 15, quotaInizio: 0, quotaFine: 0, gronda: 9,
  lavoroTetto: false, teli: false, zonaSotto: "interdetta", terreno: "asfalto", note: "", // PONT_ANC_v1
});

const inp = { width: "100%", boxSizing: "border-box", padding: "4px 6px", borderRadius: 5, border: "1px solid rgba(128,128,128,0.4)", background: "rgba(128,128,128,0.08)", color: "inherit", fontSize: 13 };
const cell = { padding: "4px 5px", borderTop: "1px solid rgba(128,128,128,0.25)", fontSize: 13, verticalAlign: "middle" };
const th = { padding: "4px 5px", fontSize: 11, opacity: 0.7, textAlign: "left", fontWeight: 600 };

// ---------------------------------------------------------------- pianta
function Pianta({ lati, selezionato, onSeleziona, giro }) { // PONT_GIRO_v1
  const sg = giro === "antiorario" ? -1 : 1;
  if (!lati.length) return null;
  let x = 0, y = 0, dir = 0;
  const seg = [];
  lati.forEach((l, i) => {
    const L = Math.max(0.1, num(l.lunghezza));
    const x2 = x + L * Math.cos(dir), y2 = y + L * Math.sin(dir);
    seg.push({ i, x1: x, y1: y, x2, y2, dir, l });
    x = x2; y = y2;
    dir -= sg * (Math.PI - num(l.angolo || 90) * Math.PI / 180);
  });
  const xs = seg.flatMap(s => [s.x1, s.x2]), ys = seg.flatMap(s => [s.y1, s.y2]);
  const minX = Math.min(...xs), maxX = Math.max(...xs), minY = Math.min(...ys), maxY = Math.max(...ys);
  const pad = 4.5, w = (maxX - minX) + 2 * pad, h = (maxY - minY) + 2 * pad;
  const sc = Math.min(560 / w, 300 / h);
  const P = (px, py) => [(px - minX + pad) * sc, (maxY - py + pad) * sc];
  const off = 1.0;
  const chiusura = Math.hypot(x, y);
  return (
    <svg width={w * sc} height={h * sc} style={{ maxWidth: "100%", background: "rgba(128,128,128,0.06)", borderRadius: 8 }}>
      {seg.map(s => {
        const [a1, b1] = P(s.x1, s.y1), [a2, b2] = P(s.x2, s.y2);
        const nx = -sg * Math.sin(s.dir), ny = sg * Math.cos(s.dir);
        const rie = l => !!l && num(l.angolo || 90) > 225 && num(l.angolo || 90) < 315; // PONT_ANGOLI_v1: negli angoli interni i tratteggi si incontrano
        const prec = s.i > 0 ? lati[s.i - 1] : (chiusura < 0.3 ? lati[lati.length - 1] : null);
        const tx = Math.cos(s.dir), ty = Math.sin(s.dir), t0 = rie(prec) ? off : 0, t1 = rie(s.l) ? off : 0;
        const [o1, p1] = P(s.x1 + nx * off + tx * t0, s.y1 + ny * off + ty * t0), [o2, p2] = P(s.x2 + nx * off - tx * t1, s.y2 + ny * off - ty * t1);
        const fl = num(s.l.lunghezza) < 4 ? 3.6 : 2.2; // PONT_FASI_v1: le scritte dei lati corti vanno piu' in fuori per non accavallarsi
        const [mx, my] = P((s.x1 + s.x2) / 2 + nx * off * fl, (s.y1 + s.y2) / 2 + ny * off * fl);
        const sel = s.i === selezionato;
        return (
          <g key={s.i} style={{ cursor: "pointer" }} onClick={() => onSeleziona(s.i)}>
            <line x1={a1} y1={b1} x2={a2} y2={b2} stroke="currentColor" strokeWidth={sel ? 4 : 2.5} />
            {s.l.ponteggio !== false && <line x1={o1} y1={p1} x2={o2} y2={p2} stroke="#f59e0b" strokeWidth={sel ? 3 : 2} strokeDasharray="6 4" />}
            <text x={mx} y={my} fontSize="12" textAnchor="middle" dominantBaseline="middle" fill="currentColor" fontWeight={sel ? 700 : 400}>
              {lettera(s.i)} · {f2(s.l.lunghezza)} m
            </text>
          </g>
        );
      })}
      {chiusura > 0.05 && lati.length > 2 && (
        <text x={6} y={14} fontSize="11" fill="#d97706">Pianta non chiusa: mancano {f2(chiusura)} m (va bene se il ponteggio non gira tutto l'edificio)</text>
      )}
    </svg>
  );
}

// ---------------------------------------------------------------- prospetto
function Prospetto({ lato, elementi, onClick, onSelezionaEl, elSel }) {
  const L = Math.max(1, num(lato.lunghezza));
  const qi = num(lato.quotaInizio), qf = num(lato.quotaFine);
  const gFc = lato.grondaFine === undefined || lato.grondaFine === null || String(lato.grondaFine).trim() === "" ? num(lato.gronda) : num(lato.grondaFine); // PONT_GRONDA_v1
  const top = Math.max(num(lato.gronda), gFc, ...elementi.map(e => num(e.quotaA))) + 2.5;
  const bot = Math.min(qi, qf, 0) - 0.5;
  const H = top - bot;
  const sc = Math.min(860 / (L + 4), 420 / H);
  const W = (L + 4) * sc, HH = H * sc;
  const X = m => (m + 1) * sc; // PONT_VISTA_v2: 0 a sinistra, come si inseriscono le misure
  const Y = q => (top - q) * sc;
  const griglia = [];
  for (let m = 0; m <= Math.floor(L); m++) griglia.push(<line key={"v" + m} x1={X(m)} y1={Y(top)} x2={X(m)} y2={Y(bot)} stroke="currentColor" strokeOpacity={m % 5 === 0 ? 0.25 : 0.08} />);
  for (let q = Math.ceil(bot); q <= Math.floor(top); q++) griglia.push(<line key={"h" + q} x1={X(-1)} y1={Y(q)} x2={X(L + 1)} y2={Y(q)} stroke="currentColor" strokeOpacity={q % 2 === 0 ? 0.18 : 0.06} />);

  const clic = e => {
    const r = e.currentTarget.getBoundingClientRect();
    const px = (e.clientX - r.left) * (W / r.width), py = (e.clientY - r.top) * (HH / r.height);
    const m = Math.round((px / sc - 1) * 10) / 10, q = Math.round((top - py / sc) * 10) / 10;
    if (m < 0 || m > L) return;
    onClick(m, q);
  };

  return (
    <svg width={W} height={HH} viewBox={`0 0 ${W} ${HH}`} style={{ maxWidth: "100%", height: "auto", background: "rgba(128,128,128,0.06)", borderRadius: 8, cursor: "crosshair" }} onClick={clic}>
      {griglia}
      <polygon points={`${X(0)},${Y(qi)} ${X(L)},${Y(qf)} ${X(L)},${Y(gFc)} ${X(0)},${Y(num(lato.gronda))}`} fill="currentColor" fillOpacity="0.07" stroke="currentColor" strokeOpacity="0.5" />
      <line x1={X(-1)} y1={Y(qi)} x2={X(0)} y2={Y(qi)} stroke="#92400e" strokeWidth="3" />
      <line x1={X(0)} y1={Y(qi)} x2={X(L)} y2={Y(qf)} stroke="#92400e" strokeWidth="3" />
      <line x1={X(L)} y1={Y(qf)} x2={X(L + 1)} y2={Y(qf)} stroke="#92400e" strokeWidth="3" />
      <line x1={X(0)} y1={Y(num(lato.gronda))} x2={X(L)} y2={Y(gFc)} stroke="currentColor" strokeWidth="2.5" />
      <text x={X(L) + 4} y={Y(gFc) - 4} fontSize="11" fill="currentColor">gronda {gFc !== num(lato.gronda) ? f2(lato.gronda) + " → " + f2(gFc) : f2(lato.gronda)} m</text>
      {elementi.map(e => {
        const t = tipoEl(e.tipo);
        const x1 = X(num(e.x)), x2 = X(num(e.x) + Math.max(0.1, num(e.larghezza)));
        const y1 = Y(Math.max(num(e.quotaA), num(e.quotaDa) + 0.1)), y2 = Y(num(e.quotaDa));
        const sel = e.id === elSel;
        if (e.inclinata) return ( // PONT_ANGOLO_v1: partenza inclinata disegnata come linea
          <g key={e.id} onClick={ev => { ev.stopPropagation(); onSelezionaEl(e.id); }} style={{ cursor: "pointer" }}>
            <line x1={X(num(e.x))} y1={Y(num(e.quotaDa))} x2={X(num(e.x) + num(e.larghezza))} y2={Y(num(e.quotaA))} stroke="transparent" strokeWidth="14" />
            <line x1={X(num(e.x))} y1={Y(num(e.quotaDa))} x2={X(num(e.x) + num(e.larghezza))} y2={Y(num(e.quotaA))} stroke={t.c} strokeWidth={sel ? 5 : 3} />
            <text x={(x1 + x2) / 2} y={Y((num(e.quotaDa) + num(e.quotaA)) / 2) - 8} fontSize="10" textAnchor="middle" fill="currentColor">Partenza inclinata</text>
          </g>
        );
        return (
          <g key={e.id} onClick={ev => { ev.stopPropagation(); onSelezionaEl(e.id); }} style={{ cursor: "pointer" }}>
            <rect x={Math.min(x1, x2)} y={y1} width={Math.max(2, Math.abs(x2 - x1))} height={Math.max(2, y2 - y1)} fill={t.c} fillOpacity={e.tipo === "no_anc" ? 0.18 : 0.35} stroke={t.c} strokeWidth={sel ? 3 : 1.5} strokeDasharray={e.tipo === "no_anc" ? "5 3" : undefined} />
            <text x={(x1 + x2) / 2} y={(y1 + y2) / 2} fontSize="10" textAnchor="middle" dominantBaseline="middle" fill="currentColor">
              {t.n.split(" ")[0]}{t.sporg && num(e.sporgenza) ? " " + f2(e.sporgenza) : ""}
            </text>
          </g>
        );
      })}
      <text x={X(0)} y={HH - 4} fontSize="11" fill="currentColor">0 · inizio</text>
      <text x={X(L)} y={HH - 4} fontSize="11" fill="currentColor" textAnchor="end">fine · {f2(L)} m</text>
    </svg>
  );
}

// ---------------------------------------------------------------- principale
export default function PonteggioCantiere({ cantiere, onChiudi }) {
  const cid = cantiere ? (cantiere._id || cantiere.id) : null;
  const [dati, setDati] = useState(null);
  const [latoSel, setLatoSel] = useState(0);
  const [elSel, setElSel] = useState(null);
  const [tipoNuovo, setTipoNuovo] = useState("balcone");
  const [modificato, setModificato] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [errore, setErrore] = useState("");

  useEffect(() => {
    if (!cid) return;
    (async () => {
      try {
        const s = await getDoc(doc(db, "impostazioni", "ponteggio_" + cid));
        const ex = s && (typeof s.exists === "function" ? s.exists() : !!s.exists);
        const d = ex ? s.data() : null;
        setDati(d && Array.isArray(d.lati) ? { lati: d.lati, elementi: d.elementi || [], note: d.note || "", valutazioni: d.valutazioni || {}, calcolo: d.calcolo || {}, pimus: d.pimus || {}, fasiModo: d.fasiModo || "insieme", giro: d.giro || "orario", distGronda: d.distGronda || "", uscita: d.uscita || null, updatedAt: d.updatedAt || "" }
                                          : { lati: [latoVuoto(0)], elementi: [], note: "", updatedAt: "" });
      } catch (e) { setErrore("Errore nel caricamento: " + e.message); setDati({ lati: [latoVuoto(0)], elementi: [], note: "", updatedAt: "" }); }
    })();
  }, [cid]);

  const chiudi = () => {
    if (modificato && !window.confirm("Ci sono modifiche non salvate. Chiudere lo stesso?")) return;
    onChiudi && onChiudi();
  };

  if (!cid) return null;
  const wrap = { position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 9999, overflowY: "auto", padding: 16 };
  const box = { maxWidth: 1100, margin: "0 auto", background: "var(--bp-card, #1b1e27)", color: "inherit", border: "1px solid rgba(128,128,128,0.35)", borderRadius: 12, padding: 18 };

  if (!dati) return <div style={wrap}><div style={box}>Carico...</div></div>;

  const lati = dati.lati, elementi = dati.elementi;
  const ls = Math.min(latoSel, lati.length - 1);
  const lato = lati[ls];
  const elLato = elementi.filter(e => e.lato === lato.id);
  const elCorr = elementi.find(e => e.id === elSel);

  const set = nuovo => { setDati(d => ({ ...d, ...nuovo })); setModificato(true); };
  const cambiaLato = (i, campo, val) => set({ lati: lati.map((l, k) => k === i ? { ...l, [campo]: val } : l) });
  const aggiungiLato = () => { set({ lati: [...lati, latoVuoto(lati.length)] }); setLatoSel(lati.length); };
  const togliLato = i => {
    const n = elementi.filter(e => e.lato === lati[i].id).length;
    if (!window.confirm("Togliere " + lati[i].nome + (n ? " e i suoi " + n + " elementi" : "") + "?")) return;
    set({ lati: lati.filter((_, k) => k !== i), elementi: elementi.filter(e => e.lato !== lati[i].id) });
    setLatoSel(0); setElSel(null);
  };
  const spostaLato = (i, d) => {
    const j = i + d; if (j < 0 || j >= lati.length) return;
    const a = [...lati]; [a[i], a[j]] = [a[j], a[i]]; set({ lati: a }); setLatoSel(j);
  };
  const cambiaEl = (id, campo, val) => set({ elementi: elementi.map(e => e.id === id ? { ...e, [campo]: val } : e) });
  const togliEl = id => { set({ elementi: elementi.filter(e => e.id !== id) }); setElSel(null); };
  const nuovoEl = (m, q) => {
    const t = tipoEl(tipoNuovo);
    const base = { id: nuovoId(), lato: lato.id, tipo: t.k, x: m, larghezza: 1, quotaDa: Math.max(0, q), quotaA: Math.max(0, q) + 1, sporgenza: t.sporg ? 1 : 0, note: "" };
    if (t.k === "balcone") { base.larghezza = 3; base.quotaA = base.quotaDa + 0.2; base.sporgenza = 1.2; }
    if (t.k === "canna") { base.larghezza = 0.6; base.quotaA = num(lato.gronda) + 1; base.sporgenza = 0.4; }
    if (t.k === "finestra") { base.larghezza = 1.2; base.quotaA = base.quotaDa + 1.4; }
    if (t.k === "passo") { base.x = m; base.larghezza = 3; base.quotaDa = 0; base.quotaA = 3; }
    if (t.k === "montacarichi") { base.larghezza = 0.3; base.quotaDa = 0; base.quotaA = Math.max(2, num(lato.gronda) - 1); base.portata = 200; base.schema = ""; }
    if (t.k === "struttura") { base.larghezza = num(lato.lunghezza) - m > 3 ? 3 : 0.3; base.quotaA = base.quotaDa + 0.3; }
    set({ elementi: [...elementi, base] }); setElSel(base.id);
  };

  const salva = async () => {
    setSalvando(true); setErrore("");
    try {
      const now = new Date().toISOString();
      await setDoc(doc(db, "impostazioni", "ponteggio_" + cid), {
        cantiereId: cid, cantiereNome: cantiere.nome || "", lati, elementi, note: dati.note || "", valutazioni: dati.valutazioni || {}, calcolo: dati.calcolo || {}, pimus: dati.pimus || {}, fasiModo: dati.fasiModo || "insieme", giro: dati.giro || "orario", distGronda: dati.distGronda || "", uscita: dati.uscita || null, versione: 1, updatedAt: now,
      });
      setDati(d => ({ ...d, updatedAt: now })); setModificato(false);
    } catch (e) { setErrore("Salvataggio non riuscito: " + e.message); }
    finally { setSalvando(false); }
  };

  const totLung = lati.reduce((s, l) => s + num(l.lunghezza), 0);
  const maxGronda = Math.max(...lati.map(l => Math.max(num(l.gronda), num(l.grondaFine))));

  return (
    <div style={wrap} onClick={chiudi}>
      <div style={box} onClick={e => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 10, flexWrap: "wrap", marginBottom: 12 }}>
          <div>
            <div style={{ fontWeight: 700, fontSize: 17 }}>🏗️ Ponteggio · {cantiere.nome}</div>
            <div style={{ fontSize: 12, opacity: 0.7 }}>
              Descrizione dell'edificio · {lati.length} {lati.length === 1 ? "lato" : "lati"} · {f2(totLung)} m di facciata · gronda max {f2(maxGronda)} m
              {dati.updatedAt && !modificato ? " · salvato il " + new Date(dati.updatedAt).toLocaleString("it-IT") : ""}
            </div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button className="btn btn-primary btn-sm" onClick={salva} disabled={salvando || !modificato}>{salvando ? "Salvo..." : modificato ? "💾 Salva" : "✓ Salvato"}</button>
            <button className="btn btn-sm" onClick={chiudi}>Chiudi</button>
          </div>
        </div>
        {errore && <div style={{ color: "#dc2626", fontSize: 13, marginBottom: 8 }}>{errore}</div>}

        <div style={{ fontWeight: 700, fontSize: 14, margin: "6px 0" }}>1 · Pianta: i lati da ponteggiare</div>
        <div style={{ fontSize: 12, marginBottom: 6, display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>Giro dei lati: <select style={{ ...inp, width: "auto" }} value={dati.giro || "orario"} onChange={e => set({ giro: e.target.value })}><option value="orario">orario</option><option value="antiorario">antiorario</option></select><span>Ultimo piano sotto la gronda m</span><input style={{ ...inp, width: 64 }} value={dati.distGronda || ""} placeholder="auto" onChange={e => set({ distGronda: e.target.value })} title="Vuoto: il programma sceglie tra 1,80 e 2,10 m" /> {/* PONT_GRIGLIA_v2 */}<span style={{ opacity: 0.7 }}>Le misure di ogni lato (elementi, terreno, gronda) si prendono da sinistra, guardando la facciata da fuori.</span></div> {/* PONT_GIRO_v1 */}
        <div style={{ fontSize: 12, opacity: 0.7, marginBottom: 6 }}>In ordine, girando attorno all'edificio. L'angolo è quello interno con il lato successivo (90° = angolo normale). Le quote del terreno sono relative (0 = punto di riferimento).</div>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1240 }}>
            <thead><tr>
              <th style={th}></th><th style={th}>Ponteggio</th><th style={th}>Fase</th><th style={th}>Nome</th><th style={th}>Lunghezza m</th><th style={th}>Angolo °</th>
              <th style={th}>Dist. muro cm</th><th style={th}>Terreno a sinistra m</th><th style={th}>Terreno a destra m</th>
              <th style={th}>Gronda a sinistra m</th><th style={th}>Gronda a destra m</th><th style={th}>Lavoro sul tetto</th><th style={th}>Teli/reti</th><th style={th}>Zona sotto</th><th style={th}>Terreno</th><th style={th}></th>
            </tr></thead>
            <tbody>
              {lati.map((l, i) => (
                <tr key={l.id} style={{ background: i === ls ? "rgba(245,158,11,0.10)" : undefined }}>
                  <td style={cell}><button className="btn btn-sm" onClick={() => { setLatoSel(i); setElSel(null); }}>{i === ls ? "●" : lettera(i)}</button></td>
                  <td style={{ ...cell, textAlign: "center" }}><input type="checkbox" checked={l.ponteggio !== false} onChange={e => cambiaLato(i, "ponteggio", e.target.checked)} title="Lato da ponteggiare" /></td> {/* PONT_SCELTE_v1 */}
                  <td style={cell}><select style={{ ...inp, width: 52 }} value={num(l.fase) || 1} disabled={l.ponteggio === false} onChange={e => cambiaLato(i, "fase", Number(e.target.value))}>{[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(f => <option key={f} value={f}>{f}</option>)}</select></td> {/* PONT_FASI_v1 PONT_FASI10_v1: fino a 10 fasi */}
                  <td style={cell}><input style={inp} value={l.nome} onChange={e => cambiaLato(i, "nome", e.target.value)} /></td>
                  <td style={cell}><input style={inp} value={l.lunghezza} onChange={e => cambiaLato(i, "lunghezza", e.target.value)} /></td>
                  <td style={cell}><input style={inp} value={l.angolo} onChange={e => cambiaLato(i, "angolo", e.target.value)} /></td>
                  <td style={cell}><input style={inp} value={l.distanzaMuro} onChange={e => cambiaLato(i, "distanzaMuro", e.target.value)} /></td>
                  <td style={cell}><input style={inp} value={l.quotaInizio} onChange={e => cambiaLato(i, "quotaInizio", e.target.value)} /></td>
                  <td style={cell}><input style={inp} value={l.quotaFine} onChange={e => cambiaLato(i, "quotaFine", e.target.value)} /></td>
                  <td style={cell}><input style={inp} value={l.gronda} onChange={e => cambiaLato(i, "gronda", e.target.value)} /></td>
                  <td style={cell}><input style={inp} value={l.grondaFine === undefined || l.grondaFine === null ? "" : l.grondaFine} placeholder={String(l.gronda)} title="Vuoto = come la gronda di inizio" onChange={e => cambiaLato(i, "grondaFine", e.target.value)} /></td> {/* PONT_GRONDA_v1 */}
                  <td style={{ ...cell, textAlign: "center" }}><input type="checkbox" checked={!!l.lavoroTetto} onChange={e => cambiaLato(i, "lavoroTetto", e.target.checked)} /></td>
                  <td style={{ ...cell, textAlign: "center" }}><input type="checkbox" checked={!!l.teli} onChange={e => cambiaLato(i, "teli", e.target.checked)} /></td>
                  <td style={cell}>
                    <select style={inp} value={l.zonaSotto} onChange={e => cambiaLato(i, "zonaSotto", e.target.value)}>
                      <option value="interdetta">Interdetta</option><option value="passaggio">Con passaggio</option>
                    </select>
                  </td>
                  <td style={cell}>
                    <select style={inp} value={l.terreno} onChange={e => cambiaLato(i, "terreno", e.target.value)}>
                      <option value="asfalto">Asfalto / cemento</option><option value="terra">Terra / ghiaia</option>
                      <option value="marciapiede">Marciapiede</option><option value="altro">Altro</option>
                    </select>
                  </td>
                  <td style={{ ...cell, whiteSpace: "nowrap" }}>
                    <button className="btn btn-sm" title="Su" onClick={() => spostaLato(i, -1)}>↑</button>{" "}
                    <button className="btn btn-sm" title="Giù" onClick={() => spostaLato(i, 1)}>↓</button>{" "}
                    <button className="btn btn-sm" title="Togli lato" onClick={() => togliLato(i)} disabled={lati.length === 1}>✕</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={{ margin: "8px 0 14px" }}><button className="btn btn-sm" onClick={aggiungiLato}>➕ Aggiungi lato</button></div>
        <Pianta lati={lati} giro={dati.giro || "orario"} selezionato={ls} onSeleziona={i => { setLatoSel(i); setElSel(null); }} />
        <div style={{ fontSize: 11, opacity: 0.6, margin: "4px 0 16px" }}>Linea piena = muro · tratteggio arancione = ponteggio (lato esterno). Clic su un lato per aprirne il prospetto.</div>

        <div style={{ fontWeight: 700, fontSize: 14, margin: "6px 0" }}>2 · Prospetto del {lato.nome} ({f2(lato.lunghezza)} m)</div>
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 8, fontSize: 13 }}>
          <span>Clic sul disegno per aggiungere:</span>
          <select style={{ ...inp, width: 300 }} value={tipoNuovo} onChange={e => setTipoNuovo(e.target.value)}>
            {TIPI_EL.map(t => <option key={t.k} value={t.k}>{t.n}</option>)}
          </select>
          <span style={{ width: 14, height: 14, borderRadius: 3, background: tipoEl(tipoNuovo).c, display: "inline-block" }} />
        </div>
        <Prospetto lato={lato} elementi={elLato} onClick={nuovoEl} onSelezionaEl={setElSel} elSel={elSel} />
        <div style={{ fontSize: 11, opacity: 0.6, margin: "4px 0 10px" }}>Griglia ogni metro (linee più marcate ogni 5 m in orizzontale e ogni 2 m in verticale). Misure "da sinistra" guardando la facciata dal ponteggio.</div>

        {elCorr && elCorr.lato === lato.id && (
          <div style={{ border: "1px solid " + tipoEl(elCorr.tipo).c, borderRadius: 8, padding: 10, marginBottom: 12 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
              <div style={{ fontWeight: 700, fontSize: 13 }}>Elemento selezionato</div>
              <button className="btn btn-sm" onClick={() => togliEl(elCorr.id)}>🗑 Togli</button>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: 8, fontSize: 12 }}>
              <label>Tipo<select style={inp} value={elCorr.tipo} onChange={e => cambiaEl(elCorr.id, "tipo", e.target.value)}>{TIPI_EL.map(t => <option key={t.k} value={t.k}>{t.n}</option>)}</select></label>
              <label>Da sinistra m<input style={inp} value={elCorr.x} onChange={e => cambiaEl(elCorr.id, "x", e.target.value)} /></label>
              <label>Larghezza m<input style={inp} value={elCorr.larghezza} onChange={e => cambiaEl(elCorr.id, "larghezza", e.target.value)} /></label>
              <label>Quota da m<input style={inp} value={elCorr.quotaDa} onChange={e => cambiaEl(elCorr.id, "quotaDa", e.target.value)} /></label>
              <label>Quota a m<input style={inp} value={elCorr.quotaA} onChange={e => cambiaEl(elCorr.id, "quotaA", e.target.value)} /></label>
              {elCorr.tipo === "montacarichi" && <><label>Portata kg<input style={inp} value={elCorr.portata || ""} placeholder="200" onChange={e => cambiaEl(elCorr.id, "portata", e.target.value)} /></label><label>Schema ingegnere (rif.)<input style={inp} value={elCorr.schema || ""} placeholder="es. schema tipo montacarichi n. 3/26" onChange={e => cambiaEl(elCorr.id, "schema", e.target.value)} /></label><div style={{ gridColumn: "1 / -1", fontSize: 11, opacity: 0.7 }}>Da sinistra = posizione del montante; Quota a = piano di sbarco più alto.</div></>} {/* PONT_MONTA_v1 */}
              {elCorr.tipo === "partenza" && <label style={{ display: "flex", gap: 6, alignItems: "center" }}><input type="checkbox" checked={!!elCorr.inclinata} onChange={e => cambiaEl(elCorr.id, "inclinata", e.target.checked)} />Partenza inclinata: da «quota da» a sinistra a «quota a» a destra (scala, tetto)</label>} {/* PONT_GIRO_v1 */}
              {tipoEl(elCorr.tipo).sporg && <label>Sporgenza dal muro m<input style={inp} value={elCorr.sporgenza} onChange={e => cambiaEl(elCorr.id, "sporgenza", e.target.value)} /></label>}
              <label style={{ gridColumn: "1 / -1" }}>Note<input style={inp} value={elCorr.note} onChange={e => cambiaEl(elCorr.id, "note", e.target.value)} placeholder="es. canna in muratura, non ancorare" /></label>
            </div>
          </div>
        )}

        {elLato.length > 0 && (
          <div style={{ overflowX: "auto", marginBottom: 12 }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 640 }}>
              <thead><tr><th style={th}>Elemento</th><th style={th}>Da sinistra</th><th style={th}>Largh.</th><th style={th}>Quote</th><th style={th}>Sporg.</th><th style={th}>Note</th></tr></thead>
              <tbody>
                {elLato.map(e => (
                  <tr key={e.id} onClick={() => setElSel(e.id)} style={{ cursor: "pointer", background: e.id === elSel ? "rgba(245,158,11,0.10)" : undefined }}>
                    <td style={cell}><span style={{ display: "inline-block", width: 10, height: 10, borderRadius: 2, background: tipoEl(e.tipo).c, marginRight: 6 }} />{tipoEl(e.tipo).n}</td>
                    <td style={cell}>{f2(e.x)} m</td><td style={cell}>{f2(e.larghezza)} m</td>
                    <td style={cell}>{f2(e.quotaDa)} → {f2(e.quotaA)} m</td>
                    <td style={cell}>{tipoEl(e.tipo).sporg ? f2(e.sporgenza) + " m" : "—"}</td>
                    <td style={cell}>{e.note}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div style={{ fontWeight: 700, fontSize: 14, margin: "6px 0" }}>3 · Progetto del ponteggio</div>
        {new Set(lati.filter(l => l.ponteggio !== false).map(l => num(l.fase) || 1)).size > 1 && ( // PONT_FASI_v1
          <div style={{ fontSize: 12, margin: "0 0 8px", display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
            <span>Montaggio in fasi:</span>
            <select style={{ ...inp, width: "auto" }} value={dati.fasiModo || "insieme"} onChange={e => set({ fasiModo: e.target.value })}>
              <option value="insieme">tutte montate insieme (servono i pezzi di tutte le fasi)</option>
              <option value="riuso">una dopo l'altra (smonto e riuso i pezzi)</option>
            </select>
          </div>
        )}
        <PonteggioProgetto descrizione={{ lati, elementi, fasiModo: dati.fasiModo || "insieme", giro: dati.giro || "orario", distGronda: dati.distGronda || "" }} latoSel={ls} valutazioni={dati.valutazioni || {}}
          cantiere={cantiere} calcolo={dati.calcolo || {}} onCalcolo={c => set({ calcolo: c })} pimus={dati.pimus || {}} onPimus={p => set({ pimus: p })} uscita={dati.uscita || null} onUscita={u => set({ uscita: u })}
          onValutazione={(k, v) => { const val = { ...(dati.valutazioni || {}) }; if (!v.livello && !v.nota) delete val[k]; else val[k] = v; set({ valutazioni: val }); }} />
        <div style={{ fontWeight: 700, fontSize: 14, margin: "16px 0 6px" }}>4 · Note per il ponteggio</div>
        <textarea style={{ ...inp, minHeight: 60 }} value={dati.note} onChange={e => set({ note: e.target.value })} placeholder="es. accesso dal cortile, gru disponibile, muro in pietra sul lato B..." />
        <div style={{ fontSize: 11, opacity: 0.6, marginTop: 8 }}>
          Le valutazioni dei punti (livello e nota) si salvano con il pulsante Salva in alto.
        </div>
      </div>
    </div>
  );
}
